// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'label-container',
    template: `
        <div class="label-container">
            <div class="label-list">
                <div class="label"
                     *ngFor="let label of currentLabels"
                     [ngStyle]="{'background-color': label.color}">
                    <div class="label-text"
                         [ngStyle]="{'color': (label.color | inverseColorCode)}"
                         *ngIf="currentLabels.length <= labelsNoBeforeMinimize">
                        {{label.name}}
                    </div>
                    <div class="label-without-text"
                         ngbTooltip="{{label.name}}"
                         *ngIf="currentLabels.length > labelsNoBeforeMinimize">
                    </div>
                </div>
            </div>
            <div class="label-btn"
                 *ngIf="allowEdit"
                 [attr.aria-label]="'Edit labels' | translate"
                 (click)="showLabelSelector = !showLabelSelector"
                 [ngClass]="{'active': showLabelSelector || showEdit}">
                <span class="label-btn-icon fas fa-tag fa-lg" aria-hidden="true">
                </span>
                <label-container-selector
                    [allLabels]="allLabels"
                    [(monShow)]="showLabelSelector"
                    (onUpdateLabel)="handleUpdateLabel()"
                    [currentLabels]="currentLabels"
                    (getLabels)="handleGetLabels()">
                </label-container-selector>
            </div>
        </div>
    `,
    standalone: false,
})
export class LabelContainerComponent implements OnInit {
    @Input() currentLabels: any[] = [];
    @Input() allLabels: any[] = [];
    @Input() allowEdit?: boolean;
    @Input() labelsNoBeforeMinimize: number = 2;
    @Output() onUpdateLabel = new EventEmitter<void>();
    @Output() getLabels = new EventEmitter<void>();
    @Output() currentLabelsChange = new EventEmitter<any[]>();

    showLabelSelector: boolean = false;
    showEdit: boolean = false;

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.showLabelSelector = false;
        this.currentLabels = this.currentLabels || [];
        this.allLabels = this.allLabels || [];
    }

    handleUpdateLabel (): void {
        this.onUpdateLabel.emit();
    }

    handleGetLabels (): void {
        this.getLabels.emit();
    }
}
